export { default } from './CharacterThumbnail';



// WEBPACK FOOTER //
// ./src/client/js/view/components/CharacterPicker/CharacterNav/CharacterThumbnail/index.js